package br.com.vvrefeicoes.portal.feature.purchases

import androidx.compose.runtime.Composable
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.compras_extra_reason_none

@Composable
internal fun extraReasonLabel(reasonName: String?): String = reasonName?.takeIf { it.isNotBlank() } ?: stringResource(Res.string.compras_extra_reason_none)
